// extracted by mini-css-extract-plugin
export default {"buttonClose":"modal_buttonClose__ZNlb6","modal":"modal_modal__Nszx8","header":"modal_header__WylpV","title":"modal_title__Td4A0"};